import React from "react";
import CategoryImg from "../categories/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Tooltip } from "antd";

const DownloadedDotsBlock = ({dots, onSelection}) => {

  const date = moment(dots.insertTimestamp);
  const formattedDate = date.format("DD MMM YYYY");

  return (
    <div className="askEdit-templateCard-root">
      <div
        className="askEdit-templateCard-item"
        onClick={() => onSelection(dots ? dots.templateId : null)}
      >
        <div
          style={{
            background: `url(${CategoryImg(dots.category)})`,
            backgroundSize: "contain"
          }}
          className="askEdit-templateCard-bg"
        >
        </div>
      </div>
      <div className="askEdit-templateCard-title-container">
        <div className="askEdit-templateCard-title">
          {dots && (
            <span>
              <FontAwesomeIcon icon={["far", "globe"]} />
            </span>
          )}
          {dots.title}
        </div>
        <Tooltip
          title={
            <div className="askEdit-templateCard-trash-container">
              <FontAwesomeIcon
                icon={["far", "trash-alt"]}
                className="askEdit-templateCard-trash"
              />
            </div>
          }
          color={"white"}
          overlayClassName={"askEdit-templateCard-tooltip"}
        >
          <FontAwesomeIcon icon={["far", "ellipsis-v"]} className="askEdit-templateCard-ellipsis"/>
        </Tooltip>
      </div>

      <div className="askEdit-templateCard-info-row">
        <span className="askEdit-templateCard-author">{dots.authorName}</span>
        <pre className="askEdit-templateCard-date">{` / ${formattedDate}`}</pre>
      </div>
    </div>
  );
};

export default DownloadedDotsBlock;